import React from "react";
import { Container, Row, Col, Image, Button, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { FaHandHoldingHeart, FaUsers, FaAward, FaTree, FaHeartbeat, FaGraduationCap } from "react-icons/fa";
import CommonBanner from "./Common";
import about from "../Assests/about.png";
import about1 from "../Assests/about1.png";
import about2 from "../Assests/about2.png";
import about_banner3 from "../Assests/about_banner3.png";
import b1 from "../Components/owner.png";
import a1 from "../Assests/Members/a1.jpeg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./About.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Import all slides
const slides = [
  { id: 1, img: require("../Assests/aboutSlider/slide1.png"), title: "a8", desc: "a9" },
  { id: 2, img: require("../Assests/aboutSlider/slide2.png"), title: "a10", desc: "a11" },
  { id: 3, img: require("../Assests/aboutSlider/slide3.png"), title: "a12", desc: "a13" },
  { id: 4, img: require("../Assests/aboutSlider/slide4.png"), title: "a14", desc: "a15" },
  { id: 5, img: require("../Assests/aboutSlider/slide5.png"), title: "a16", desc: "a17" },
  { id: 6, img: require("../Assests/aboutSlider/slide6.png"), title: "a18", desc: "a19" },
  { id: 7, img: require("../Assests/aboutSlider/slide7.png"), title: "a20", desc: "a21" },
  { id: 8, img: require("../Assests/aboutSlider/slide8.png"), title: "a22", desc: "a23" },
  { id: 9, img: require("../Assests/aboutSlider/slide9.png"), title: "a24", desc: "a25" },
  { id: 10, img: require("../Assests/aboutSlider/slide10.png"), title: "a26", desc: "a27" },
  { id: 11, img: require("../Assests/aboutSlider/slide11.png"), title: "a28", desc: "a29" },
  { id: 12, img: require("../Assests/aboutSlider/slide12.png"), title: "a30", desc: "a31" },
  { id: 13, img: require("../Assests/aboutSlider/slide13.png"), title: "a32", desc: "a33" },
  { id: 14, img: require("../Assests/aboutSlider/slide14.png"), title: "a34", desc: "a35" },
  { id: 15, img: require("../Assests/aboutSlider/slide17.png"), title: "a36", desc: "a37" },
  { id: 16, img: require("../Assests/aboutSlider/slide18.png"), title: "a38", desc: "a39" },
];

const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const advocate = [{ id: 1, name: "Advocate Naveen Kumar Raheja", title: "Legal Advisor", img: a1 }];
  const activeMembers = [
    "Gautam Kumar", "Pramod kumar", "Jyoti Kumari", "Harish Kumar",
    "Ashutosh Gupta", "Mukesh Kumar", "Sandeep Kumar", "Gaurav Kumar",
  ];

  const stats = [
    { icon: FaUsers, value: "5000+", label: "Lives Impacted" },
    { icon: FaHeartbeat, value: "50+", label: "Health Camps" },
    { icon: FaGraduationCap, value: "2000+", label: "Students Supported" },
    { icon: FaTree, value: "10000+", label: "Trees Planted" },
    { icon: FaAward, value: "15+", label: "Awards Received" },
    { icon: FaHandHoldingHeart, value: "100+", label: "Events Organized" },
  ];

  return (
    <>
      <CommonBanner image={about} />
      <div className="about-page">
        <Container>
          {/* Hero Section */}
          <Row className="hero-section align-items-center">
            <Col lg={6}>
              <div className="hero-content">
                <h1 className="hero-title">{t("a1")}</h1>
                <p className="hero-text">{t("a2")}</p>
                <p className="hero-text">{t("a3")}</p>
                <Button className="donate-btn-sm" onClick={()=>navigate("/whydonation")}>Donate Now</Button>
              </div>
            </Col>
            <Col lg={6} className="text-center">
              <Image src={about1} fluid className="hero-image" />
            </Col>
          </Row>

          {/*  
          <Row className="stats-section">
            {stats.map((stat, idx) => (
              <Col lg={2} md={4} sm={6} key={idx}>
                <div className="stat-card">
                  <stat.icon className="stat-icon" />
                  <h3 className="stat-value">{stat.value}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row> */}

          {/* Mission Section */}
          <Row className="mission-section align-items-center">
            <Col lg={6}>
              <Image src={about2} fluid className="mission-image" />
            </Col>
            <Col lg={6}>
              <div className="mission-content text-lg-end text-center">
                <h2 className="section-title">{t("a5")}</h2>
                <p>{t("a6")}</p>
                <p>{t("a7")}</p>
              </div>
            </Col>
          </Row>
 
          <div className="slider-section" style={{ backgroundImage: `url(${about_banner3})` }}>
            <Swiper
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={30}
              slidesPerView={1}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              pagination={{ clickable: true, el: ".custom-pagination" }}
              className="about-swiper"
            >
              {slides.map((slide) => (
                <SwiperSlide key={slide.id}>
                  <Row className="align-items-center">
                    <Col lg={7}>
                      <div className="slide-content">
                        <h3 className="slide-title">{t(slide.title)}</h3>
                        <p className="slide-desc">{t(slide.desc)}</p>
                      </div>
                    </Col>
                    <Col lg={5} className="text-center">
                      <Image src={slide.img} fluid className="slide-image" />
                    </Col>
                  </Row>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="custom-pagination"></div>
          </div>

          {/* Board Member Section */}
          <div className="members-section">
            <h2 className="section-title text-center">{t("a46")}</h2>
            <Row className="justify-content-center">
              <Col lg={4} md={6}>
                <Card className="member-card">
                  <Card.Img variant="top" src={b1} />
                  <Card.Body className="text-center">
                    <h4>Kshitij Ranjan</h4>
                    <p>{t("a47")}</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
 
          <div className="members-section">
            <h2 className="section-title text-center">{t("a48")}</h2>
            <Row className="justify-content-center">
              {advocate.map((adv) => (
                <Col lg={4} md={6} key={adv.id}>
                  <Card className="member-card">
                    <Card.Img variant="top" src={adv.img} />
                    <Card.Body className="text-center">
                      <h4>{adv.name}</h4>
                      <p>{adv.title}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Active Members List */}
          <div className="members-list-section">
            <h2 className="section-title text-center">{t("a50")}</h2>
            <div className="members-grid">
              {activeMembers.map((member, idx) => (
                <div key={idx} className="member-tag">
                  {member}
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default About;